import { useEffect, useState } from "react";

export default function Hero() {
  const images = [
    "/ground2.jpg",
     "/ground1.jpeg",
     "/ground11.jpeg",
    "/ground3k.jpeg",
    "/ground4.jpg",
    "/ground5.jpeg",
    "/ground8.jpeg",
    
  ];

  const [current, setCurrent] = useState(0);

  // 🎞️ Background Slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]); // ✅ Add images.length as dependency

  return (
    <section id="home" className="pt-28 relative min-h-screen">
      {/* Background Slider */}
      {images.map((img, index) => (
        <div
          key={index}
          className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-1000 bg-gradient-to-t from-black/80 via-black/50 to-black/30 ${
            index === current ? "opacity-100" : "opacity-0"
          }`}
          style={{ backgroundImage: `url(${img})` }}
        />
      ))}

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Content */}
     <div className="relative z-10 flex flex-col items-center text-center text-white px-4 min-h-[calc(100vh-7rem)]">

  {/* TITLE */}
  

  {/* SUBTITLE */}
  <p className="mt-4 text-lg md:text-xl max-w-xl text-gray-200">
    Join the best cricket academy in Chennai and improve your game with 
    professional coaching.
  </p>

  {/* BUTTONS */}
  <div className="mt-6 flex gap-4 flex-wrap justify-center">
    
    {/* JOIN BUTTON */}
     <a
    href="#admission"
    className="bg-[#D4AF37] text-black px-6 py-3 rounded-xl font-semibold hover:scale-105 hover:shadow-xl transition inline-block"
  >
    Join Now
  </a>
    {/* LIVE BUTTON */}
  
  </div>

  {/* PUSH TO BOTTOM */}
  <div className="flex-grow"></div>

  {/* BOTTOM CTA */}
  <div className="mb-8">
     <a
      href="https://www.cricbuzz.com/cricket-match/live-scores"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-white/10 backdrop-blur-md border border-white/20 px-6 py-3 rounded-xl font-semibold hover:bg-white/20 transition flex items-center gap-2"
    >
      🏏 Live Score
      <span className="text-red-500 animate-pulse">●</span>
    </a>
    </div>

</div>
    </section>
  );
}